import React from 'react';
import PropTypes from 'prop-types';

import FilterSet from 'components/Explorer/models/filter_set';
import InputField from './InputField';

const HandlePrefixFilter = ({ filterSet, initialSearch }) => (
  <InputField
    filterSet={filterSet}
    initialSearch={initialSearch}
    name="handle_prefix"
    id="filter_handle_prefix"
    type="handle_prefixes"
    label={I18n.t('Explorer.AdvancedSearch.fields.handle_prefix.title')}
    helpUrl={I18n.t('Explorer.AdvancedSearch.help_uri')}
    helpTip={I18n.t('Explorer.AdvancedSearch.fields.handle_prefix.help')}
    analyticsEventPrefix="Advanced Search: Field"
    analyticsFieldName="Handle Prefix"
    placeholder={I18n.t('Explorer.AdvancedSearch.fields.handle_prefix.placeholder')}
  />
);

HandlePrefixFilter.propTypes = {
  filterSet: PropTypes.instanceOf(FilterSet).isRequired,
  initialSearch: PropTypes.string
};

export default HandlePrefixFilter;
